import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import defaultPortrait from '../../styles/images/stuDefault.png';
import 'echarts/lib/chart/bar';

import NHFetch from '../../utils/NHFetch.js';
import styles from './styles.css';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 30 * 1000; //轮询时间间隔
const pageSize = 5; //分页显示每页数据数量

/**
 * 最新报到同学
 * Author: sunyu
 * Created on: 2020年10月14日15:42:11
 */
export default class _BarBox1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各专业报到统计数据
            page: 0, //当前显示的页数
            activeBarData: [] //当前显示的数据
        };

        this.polling;
        this.activePolling;
    }

    componentDidMount() {
        this.getData();
    }
    createUuid = () => {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
    }

    // 组件卸载时清除定时器
    componentWillUnmount() {
        if (this.polling) {
            clearTimeout(this.polling);
        }
        if (this.activePolling) {
            clearInterval(this.activePolling);
        }
    }

    /**
     * * 获取各专业报到统计数据
     * @memberof _BarBox1
     */
    getData = () => {

        NHFetch(yxxtBasicUrl + '/sstj/getSszyNewlyReportedStudents?num=40', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);

                    let data = res.data;
                    let barData = [];
                    let pageItems = [];

                    //如果数据量超过每页最大显示数量，则做分页显示处理
                    data.map((item, index) => {

                        pageItems.push(item);

                        if ((index + 1) % pageSize == 0 || index == data.length - 1) {
                            barData.push(pageItems);
                            pageItems = [];
                        }
                    });

                    this.setState({ errCount: 0, barData: barData, activeBarData: barData[0], newestInfo: res.data }, () => {

                        if (this.activePolling) {
                            clearInterval(this.activePolling);
                        }

                        //隔5秒换页
                        this.activePolling = setInterval(() => {
                            let { page, barData } = this.state;
                            const length = barData.length;

                            if (page + 1 >= length) {
                                page = 0;
                            } else {
                                page += 1;
                            }
                            let activeBarData = barData[page];

                            this.setState({ page, activeBarData });
                        }, 5000);
                    });

                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                    if (this.activePolling) {
                        clearInterval(this.activePolling);
                    }

                }
            });
    };

    render() {
        const { newestInfo = [] } = this.state
        let newEst = newestInfo[0] || {}
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div className={styles.newestTitle}>
                    最新报到同学
                </div>
                <div style={{ minHeight: 165 }}>
                    <div className={styles.newestImgBox}>
                        <div style={{ height: '100%' ,overflow:'hidden'}}>
                            <img
                                src={`api/sm-student/openapi/getStudentPhoto?xsid=${newEst.xsid}&type=10&uuid=${this.createUuid()}`}
                                onError={e => {
                                    e.target.src = defaultPortrait
                                }}
                                style={{ width: '100%' }} />
                        </div>
                    </div>

                    {/* // <div className={styles.newestInfoBox}> */}
                    <div className={styles.titleLine}  >
                        <span className={styles.newestInfoLine1}>姓名</span>
                        <span className={styles.newestInfoLine2}>{newEst.xm}</span>
                    </div>
                    <div className={styles.titleLine} >
                        <span className={styles.newestInfoLine1}>性别</span>
                        <span className={styles.newestInfoLine2}>{newEst.xb}</span>
                    </div>
                    <div className={styles.titleLine} >
                        <span className={styles.newestInfoLine1}>学院</span>
                        <span className={styles.newestInfoLine2}>{newEst.xymc}</span>
                    </div>
                    <div className={styles.titleLine}  >
                        <span className={styles.newestInfoLine1}>专业</span>
                        <span className={styles.newestInfoLine2}>{newEst.zymc}</span>
                    </div>
                    <div className={styles.titleLine} style={{ margin: '10px 0 0 -14px' }} >
                        <span className={styles.newestInfoLine1}>生源地</span>
                        <span className={styles.newestInfoLine2}>{newEst.province}-{newEst.city}
                        {/* -{newEst.county} 去掉区镇 */}
                        </span>
                    </div>

                    {/* // </div> */}
                </div>
                <div className={styles.doubleLine}>
                </div>
                <div className={styles.newestInfo} style={{ height: 560 }}>
                    <div className={styles.animation}>
                        {
                            newestInfo.map((item) => {
                                return (
                                    <div className={styles.newestInfoLine}>
                                        <span className={styles.newestInfoLine1}>{item.xm}</span>
                                        <span className={styles.newestInfoLine2}>{item.xymc}</span>
                                        <span className={styles.newestInfoLine3}>{item.bdsj}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/Show-sszy/_BarBox1.js